import { ReactNode } from "react"

import style from "modules/SelectionOfPsychologists/SurveyResultsPage/style.module.scss"
import { useDidMount } from "utils/customHooks"
import { PageHeader } from "components/Header/PageHeader"
import { getRootNode } from "utils/getRootNode"
import { Footer } from "components"

interface Props {
    header: ReactNode
    body: ReactNode
    showDiscount?: boolean
}

export function SurveyResultsPage({ header, body }: Props) {
    useDidMount(() => {
        //background-color для всего ClientSurvey прописан в App.js, поэтому это самый дешевый способ заменить его
        const { classList } = getRootNode() ?? {}
        classList?.add("search-results-redesign")
        return () => classList?.remove("search-results-redesign")
    })

    return (
        <>
            <PageHeader openLogo={{ newTab: true }} showRight="discount" />
            <div className={style.container}>
                <div className={style.redesignContainer}>
                    <div className={style.heading}>{header}</div>
                </div>
            </div>
            <div className={style.redesignContainer}>
                <div className={style.surveyResults}>{body}</div>
            </div>
            <Footer />
        </>
    )
}
